module.exports = __webpack_public_path__ + "static/6h-helpful-5e73fc4d318e03aa1f3de22e3cd854ac.png";